import { ReactNode } from "react";
import RadiusCard from "@components/layout/RadiusCard";
import RadiusBoxLabel from "@components/layout/RadiusBoxLabel";
import { isGasSkinV2 } from "./useGasSkin";
import { SkinCard, SkinSectionLabel } from "./SkinV2";

export * from "./SkinV2";
export * from "./useGasSkin";

/**
 * 換皮轉接層：瓦斯訂購各頁一律用 GasCard / GasLabel，
 * 由 isGasSkinV2() 決定渲染 V1（原本的 RadiusCard / RadiusBoxLabel）或 V2（扁平白卡 / 純粗體標題）。
 * 這樣換皮不必在頁面裡到處寫三元判斷，V1 的輸出也與改動前逐字相同。
 */
export const GasCard = ({ children, id }: { children: ReactNode; id?: string }) =>
  isGasSkinV2() ? <SkinCard id={id}>{children}</SkinCard> : <RadiusCard id={id}>{children}</RadiusCard>;

type LabelTheme = "primary" | "amber" | "purple" | "green" | "gray";

/** V1 保留圖示色塊；V2 只留粗體區塊標題（圖示與 theme 在 V2 忽略）。 */
export const GasLabel = ({
  label,
  desc,
  icon,
  theme = "primary",
}: {
  label: string;
  desc?: string;
  icon?: ReactNode;
  theme?: LabelTheme;
}) =>
  isGasSkinV2() ? (
    <SkinSectionLabel label={label} hint={desc} />
  ) : (
    <RadiusBoxLabel label={label} desc={desc} icon={icon} theme={theme} />
  );
